import React from 'react'

export type ReviewItem = { id: string; symbol: string; name?: string | null; logo_url?: string | null }

type Ctx = {
  open: boolean
  item: ReviewItem | null
  openReview: (item: ReviewItem) => void
  close: () => void
}

const Ctx = React.createContext<Ctx | undefined>(undefined)

export function useReviewModal() {
  const ctx = React.useContext(Ctx)
  if (!ctx) throw new Error('useReviewModal must be used within ReviewModalProvider')
  return ctx
}

export function ReviewModalProvider({ children }: { children: React.ReactNode }) {
  const [open, setOpen] = React.useState(false)
  const [item, setItem] = React.useState<ReviewItem | null>(null)
  const openReview = React.useCallback((it: ReviewItem) => { setItem(it); setOpen(true) }, [])
  const close = React.useCallback(() => setOpen(false), [])
  return (
    <Ctx.Provider value={{ open, item, openReview, close }}>
      {children}
    </Ctx.Provider>
  )
}

